import { graphql, useStaticQuery } from 'gatsby';

const useEstadistica = () => {

    const data = useStaticQuery(graphql`
        query {
            allDatoCmsEstadistica(sort: { fields: idestadistica, order: DESC }) {
                nodes {
                    titulo
                    numero
                }
            }
        }
    `);

    return data.allDatoCmsEstadistica.nodes.map(estadistica => ({
        titulo: estadistica.titulo,
        numero: estadistica.numero
    }));
}
 
export default useEstadistica;